import React from 'react';
import DashContainer from 'modules/dashboard/_common/DashContainer';
import CashierSessionPage from 'modules/restaurant/cashier/CashierSessionPage';

export default function DashRestaurantCashierSession() {
    return (
        <DashContainer title='Relatório de Caixa'>
            <CashierSessionPage />
        </DashContainer>
    );
}
